<div [formGroup]="form">
    <div class="form-group">
        <label id="piCategory">{{ 'Category' | translate }}</label>
        <ng-select
            [options]="categoryOpts"
            placeholder="&nbsp;"
            ariaLabelledBy="piCategory"
            formControlName="category"
        ></ng-select>
    </div>
    <div class="form-group">
        <label id="piSubCategory">{{ 'Subcategory' | translate }}</label>
        <ng-select
            [options]="subCategoryOpts"
            placeholder="&nbsp;"
            ariaLabelledBy="piSubCategory"
            formControlName="subCategory"
        ></ng-select>
    </div>
    <div class="form-group">
        <label id="piDefinition">{{ 'Definition' | translate }}</label>
        <ng-select
            [options]="definitionOpts"
            placeholder="&nbsp;"
            ariaLabelledBy="piDefinition"
            formControlName="definition"
        ></ng-select>
    </div>
</div>
